<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>
      <h1>Accountants voor particulieren</h1>
      <p>
        Weet u op welke toeslag u jaarlijks recht heeft en waar uw geld precies
        naartoe gaat? Een accountant kan deze vragen snel en eenvoudig voor u
        beantwoorden. Hieronder vindt u een overzicht van de werkzaamheden die
        accountants voor u kunnen verrichten.
      </p>

      <h2>Aangifte inkomstenbelasting</h2>
      <p>
        In Nederland zijn we allemaal verplicht jaarlijks onze belastingaangifte
        te doen bij de Belastingdienst. Omdat hier veel ingewikkelde regels aan
        verbonden zijn, die ook nog eens jaarlijks kunnen veranderen, vinden
        veel mensen dit een lastige taak. Als particulier kunt u uw
        belastingaangifte uitbesteden aan een accountant. Accountants zijn exact
        op de hoogte van de meest actuele wet- en regelgeving. Zo kunnen ze er
        voor zorgen dat een aangifte zo voordelig mogelijk voor u uitpakt.
      </p>

      <h2>Toeslagen aanvragen</h2>
      <p>
        Wist u dat de overheid vier toeslagen opgesteld heeft die een
        aanzienlijke bijdrage aan uw huishouden kunnen leveren? Deze toeslagen
        zijn;
      </p>
      <ul>
        <li>Zorgtoeslag</li>
        <li>Kinderbijslag</li>
        <li>Huurtoeslag</li>
        <li>Kinderopvangtoeslag</li>
      </ul>
      <p>
        Wilt u weten waar u recht op heeft en hoeveel dat per jaar is?
        Accountants kunnen dit voor u uitzoeken en ook nog eens de toeslagen
        aanvragen. Zo profiteert u maximaal van de fiscale voordelen!
      </p>

      <h2>Overzicht van uw financiën</h2>
      <p>
        Als u het lastig vindt bij te houden waar uw geld naartoe gaat, maar
        hier wel maandelijks een overzicht van wilt, kunt u ook een accountants
        raadplegen. Aan de hand van uw in- en uitgavenpatroon krijgt u een
        duidelijk financieel overzicht. Zo kunnen accountants ook meteen met u
        meedenken over de besparingen.
      </p>

      <h2>Documenten digitaliseren</h2>
      <p>
        Het bijhouden van financiële documenten in een map op zolder is niet
        meer van nu. Om alles in één overzicht en snel bij de hand te hebben,
        digitaliseren sommige accountants uw verzekeringspapieren, loonstrookjes
        en andere waardevolle papieren. Deze documenten komen op een DVD of een
        beschermde website te staan. Zo raakt u niets meer kwijt en vindt u uw
        documenten snel terug.
      </p>
      <p>
        Uw administratie overdragen aan een accountant brengt veel voordelen met
        zich mee. Zo krijgt u altijd persoonlijk en juridisch advies van deze
        financieel adviseur. En uw adviseur geeft u op de door u aangegeven
        tijdstippen een actueel overzicht van uw administratie. Vraag
        verschillende offertes aan bij accountants in uw regio en bespaar op uw
        kosten! Via Accountantvergelijker.nl komt u meteen in aanraking met de
        beste bedrijven.
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks.vue'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      title: 'Op zoek naar een accountant?',
      description:
        'Vul je postcode in en vergelijk geheel gratis 6 offertes van vakkundige Bedrijven uit jouw regio ✓ Dé beste prijs voor jouw Reparatie ✓ Bespaar tot 40%',
    }
  },
}
</script>
